import script from "./employee-salary.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-salary.vue?vue&type=script&setup=true&lang=js"

import "./employee-salary.vue?vue&type=style&index=0&id=5a5614e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5614e0"]])

export default __exports__